export const store = {
    live: null,
    playerCanPopup: false,

    // livePlace: null,
    // liveTimezone: null,
    liveTrack: {
        pk: 0,
    },
    showSchedule: false,

    liveList: [],
    // liveFuture: [],
    groupedLiveList: [],

    playlist: { items: [] },
    playingItem: {
        title: "",
        artist: "",
        duration: 0,
    },

    jingles: [],

    present: null,

    authenticated: false,
    lastPayed: null,
    accountActive: false,
    valid: false,
    expireTime: 365,
    expireWarning: 345,
    giftEligible: true,
    userID: 0,
    confirmed: false,
    likes: [],

    publicPlayerStatus: "loading",

    privatePlayerStatus: "off",
    privatePlayerVisible: false,
    privatePlayerItem: { audio: null, type: null },
    privatePlayerItemID: null,
    privatePlayerChanged: false,

    showSubWarnPopup: false,
    showSubExpiredPopup: false,
    showSwitchPopup: false,
    showAddPopup: false,
    listFull: false,
    showSupportPopup: false,
    showLikePopup: false,

    allowJingle: true,
    clickedPlay: 0,

    mobileMenu: false,

    plan: null,

    streams: [],

    selectedTags: [],
    selectedSeries: [],

    bannerVisible: true,

    archiveScrollPos: 0,
    archiveTagChanged: false,
    seriesVisible: false,
    cart: {
        items: [],
        shipping: {
            id: 0,
            title: "",
            price: 0,
        },
    },
};
